.match-score(class=visitor)
  .match-flag
  .score
    p #{score}
  .team
    p #{name}
